import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';

const DriverTransactionRowActions = ({ transaction, canDelete, onView, onDelete }) => {
    const [open, setOpen] = useState(false);
    const [dropUp, setDropUp] = useState(false);
    const ref = useRef(null);
    const menuRef = useRef(null);

    const updateMenuDirection = () => {
        if (!ref.current || !menuRef.current) return;
        const buttonRect = ref.current.getBoundingClientRect();
        const menuHeight = menuRef.current.offsetHeight || 120;
        const spaceBelow = window.innerHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;
        setDropUp(spaceBelow < menuHeight + 16 && spaceAbove > spaceBelow);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        window.addEventListener('resize', updateMenuDirection);
        window.addEventListener('scroll', updateMenuDirection, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
            window.removeEventListener('resize', updateMenuDirection);
            window.removeEventListener('scroll', updateMenuDirection, true);
        };
    }, []);

    useEffect(() => {
        if (open) {
            requestAnimationFrame(updateMenuDirection);
        }
    }, [open]);

    const handleView = () => {
        setOpen(false);
        onView && onView(transaction);
    };

    const handleDelete = () => {
        setOpen(false);
        onDelete && onDelete(transaction);
    };

    return (
        <div className="relative inline-flex justify-center" ref={ref}>
            <button
                type="button"
                aria-label="Transaction actions"
                title="Transaction actions"
                aria-expanded={open}
                onClick={() => {
                    setOpen((current) => {
                        const next = !current;
                        if (next) {
                            requestAnimationFrame(updateMenuDirection);
                        }
                        return next;
                    });
                }}
                className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-600 shadow-none hover:border-slate-400 hover:bg-slate-100"
            >
                <FontAwesomeIcon icon={faEllipsisV} className="text-sm" />
            </button>

            {open && (
                <div
                    ref={menuRef}
                    className={`absolute right-0 z-[60] min-w-[170px] overflow-hidden rounded-sm border border-slate-200 bg-white py-1 text-left shadow-lg ${dropUp ? 'bottom-9' : 'top-9'}`}
                >
                    <button
                        type="button"
                        className="flex w-full items-center gap-2 px-3 py-2 text-xs text-slate-700 hover:bg-slate-100"
                        onClick={handleView}
                    >
                        <FontAwesomeIcon icon={faEye} className="w-3" />
                        View
                    </button>
                    {canDelete && (
                        <button
                            type="button"
                            className="flex w-full items-center gap-2 px-3 py-2 text-xs text-red-600 hover:bg-red-50"
                            onClick={handleDelete}
                        >
                            <FontAwesomeIcon icon={faTrash} className="w-3" />
                            Delete
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default DriverTransactionRowActions;
